<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    :submitting="submitting"
    :submitTitle="submitTitle"
    icon="fa-comment-lines"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm" :labelColumnSize="3">
      <FormRow label="Method">
        <FormSelect :options="commMethodTypeLookup" v-model="item.methodType" field="methodType" />
      </FormRow>
      <FormRow label="Template Type">
        <FormSelect :options="messageTemplateTypeLookup" v-model="item.templateType" field="templateType" />
      </FormRow>
      <FormRow label="Default">
        <FormCheckbox v-model="item.isDefault" field="isDefault" />
      </FormRow>
      <FormRow label="Name">
        <FormInputText v-model="item.name" field="name" />
      </FormRow>
      <FormRow label="Subject">
        <FormInputText v-model="item.templateSubject" field="templateSubject" />
      </FormRow>
      <FormRow label="Message">
        <div>
          <DropdownMenu title="Insert Placeholder" class="float-right mb-1" v-if="!loading">
            <DropdownMenuItem v-for="placeholder in placeholderList" :key="placeholder.code" @click="addPlaceholder(placeholder)">{{placeholder.name}}</DropdownMenuItem>
          </DropdownMenu>
          <Spinner class="float-right" v-if="loading" />
          <span class="font-weight-bold">Template</span>
        </div>
        <MessageTemplateEditor ref="templateEditor" v-model="item.templateContent" field="templateContent" />
      </FormRow>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'
import MessageTemplateEditor from '@/modules/admin/components/messageTemplateEditor'
import { CommunicationMethodTypeLookup, MessageTemplateTypeLookup } from '@/store/types'

export default {
  name: 'MessageTemplateEditDialog',
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog,
    MessageTemplateEditor
  },
  props: {
    isCreateMode: Boolean
  },
  data() {
    return {
      id: null,
      item: {},
      dialogForm: {},
      submitting: false,

      loading: false,

      placeholderList: [],

      commMethodTypeLookup: CommunicationMethodTypeLookup,
      messageTemplateTypeLookup: MessageTemplateTypeLookup
    }
  },
  watch: {
    'item.templateType': function(newVal, oldVal) {
      this.item.templateType = newVal
      this.requestData()
    }
  },
  mounted() {
    this.requestData()
  },
  computed: {
    title() {
      return this.isCreateMode ? 'New Template' : 'Edit Template'
    },
    submitTitle() {
      return this.isCreateMode ? 'Create' : 'Update'
    },
  },
  methods: {
    show(item) {
      // Reset form
      this.item = { }
      this.id = 0
      this.dialogForm = {}
      this.submitting = false

      if(item != null) {
        this.item = _.cloneDeep(item)
        this.id = item.id
      }

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var updateData = _.cloneDeep(this.$data.item)

      if(this.isCreateMode) {
        this.$apiService.adminService.createMessageTemplate(updateData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.dialogForm = this.processFormResponse(err)
        })
      } else {
        this.$apiService.adminService.updateMessageTemplate(this.id, updateData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.dialogForm = this.processFormResponse(err)
        })
      }
    },
    requestData() {
      this.loading = true

      this.$apiService.adminService.getMessageTemplatePlaceholderList(this.item.templateType)
      .then(result => {
        this.$data.placeholderList = result.data
      })
      .finally(() => {
        this.loading = false
      })
    },
    addPlaceholder(placeholder) {
      this.$refs.templateEditor.insertPlaceholder(placeholder.code)
      
    }
  }
}
</script>